<template>
  <div
    ref="accordion"
    class="accordion"
  >
    <div class="accordion__title">
      <slot
        v-if="this.$slots.heading"
        name="heading"
      />
      <p
        v-else
        v-text="title"
      />
      <button
        :aria-expanded="active ? 'true' : 'false'"
        :aria-controls="accordionId"
        class="accordion__arrow"
        @click="toggle(), pushTagging()"
      >
        <svg
          v-if="customIcon"
          aria-hidden="true"
          :class="['icon', { 'icon--opened' : active }]"
          role="img"
        >
          <use :xlink:href="`#${customIcon}`" />
        </svg>
        <div
          v-else
          :class="['icon-trigger', { 'icon-trigger--turn': active } ]"
        >
          <span />
          <span />
        </div>
      </button>
    </div>

    <div
      v-show="active"
      :id="accordionId"
      class="accordion__content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  import { AnalyticsHandler } from '@Foundation/analyticsHandler';
  import kebab from 'lodash.kebabcase';

  export default {
    name: 'Accordion',
    props: {
      customIcon: {
        default: null,
        type: String,
      },
      initialDisplay: {
        default: false,
        type: Boolean,
      },
      title: { type: String, required: true, default: 'Accordion Title' },
      expandLabel: { type: String, required: false, default: 'Expand' },
      collapseLabel: { type: String, required: false, default: 'Collapse' },
      eventCategory: { type: String, required: false, default: '' },
      eventDetail: { default: null, type: String},
      eventLabel: { type: String, required: false, default: '' },
      eventName: { default: null, type: String },
      eventProductInfo: { default: null, type: String },
      eventAction: { type: String, required: false, default: '' },
      eventTopic: { type: String, required: false, default: '' }
    },
    data() {
      return {
        active: false,
        accordionId: kebab(`accordion-${this.title}-${parseInt(Math.random() * 10000)}`)
      };
    },
    computed: {
      taggingEvent() {
        if (!(this.eventLabel.length && this.eventCategory.length && this.eventAction.length)) {
          return null;
        }

        const toggleAction = this.eventAction.split(/^(.*?)::/);
        let action = this.eventAction;

        if (toggleAction && toggleAction[1]) {
          action = `${toggleAction[1]}::${this.active ? 'open' : 'minimize'}`;
        }

        return {
          'event': 'uaevent',
          event_detail: this.eventDetail,
          event_name: this.eventName,
          'ecommerce': undefined,
          'eventCategory': this.eventCategory,
          'eventAction': action,
          eventLabel: this.eventLabel,
          product_info: this.eventProductInfo,
          topic: this.eventTopic
        };
      }
    },
    mounted() {
      this.$parent.$on('expanded-child-accordion', this.accordionGroupEvent);
      this.active = this.initialDisplay;
    },
    methods: {
      accordionGroupEvent(id) {
        if (this.accordionId !== id) {
          this.close();
        }
      },
      toggle() {
        this.active = !this.active;
        this.$emit('toggled-accordion', this.active);
        if (this.active) {
          this.$parent.$emit('expanded-accordion', this.accordionId);
        }
      },
      close() {
        this.active = false;
      },
      pushTagging() {
        if (!this.taggingEvent) {
          return;
        }

        /* instanbul ignore next */
        AnalyticsHandler.pushDataLayer(this.taggingEvent);
      }
    }
  };
</script>

<style src="./Accordion.scss" lang="scss">
